import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import { RightOutline, LeftOutline } from 'antd-mobile-icons'
import './PaymentOptions.css';
import { getInfo } from '../request/api'
import { Toast, Picker, Collapse, Button } from 'antd-mobile'
import { setItem, getItem } from "../utils/localStorage";

export default function PaymentOptions() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const [userInfo, setUserInfo] = useState({})


    const isTx = new URLSearchParams(location.search).get('w') === '1';

    const [activeNames, setActiveNames] = useState([0]);
    const [active, setActive] = useState(0);

    const getData = async () => {
        const res = await getItem("userInfo")
        setUserInfo(res)
    }
    useEffect(() => {
        if (
            userInfo?.cates?.length &&
            userInfo.cates[0]?.child?.length
        ) {
            setActive(userInfo.cates[0].child[0].id);
        }
    }, [userInfo]);

    const typeChange = (group, item) => {
        setActive(item.id);
    };

    const goJiaoyi = () => {
        if (isTx) {
            navigate(`/Withdraw?payId=${active}`);
        } else {
            navigate(`/newPay2?payId=${active}`);
        }
    };
    const nodeFun = () => { }
    nodeFun()
    useEffect(() => {
        getData()
    }, [])
    return (
        <div className="pay-page2">
            <div className='header'>
                <div className='backIcon' onClick={() => { navigate(-1) }}>
                    <LeftOutline />
                </div>
                <p>{t('zf3')}</p>
            </div>
            <p className="title">{t('zf4')}</p>
            {userInfo.cates?.map((v, i) => (
                <Collapse key={v.id} defaultActiveKey={['1']} className='Collapse'>
                    <Collapse.Panel key={i + 1} title={
                        <div className="biaoti">
                            <img src={v.image} alt="" />
                            <span>{v.name}</span>
                        </div>
                    }>
                        <div className="list">
                            {v.child.map((item) => (
                                <div
                                    key={item.id}
                                    className={`item ${active === item.id ? 'active' : ''}`}
                                    onClick={() => typeChange(v, item)}
                                >
                                    <div className="lf">
                                        <img src={item.image} alt="" />
                                        <span>{item.name}</span>
                                    </div>
                                    <img
                                        className="rg"
                                        src={
                                            active === item.id
                                                ? '/assets/images/yxz.png'
                                                : '/assets/images/wxz.png'
                                        }
                                        alt=""
                                    />
                                </div>
                            ))}
                        </div>
                    </Collapse.Panel>
                </Collapse>))}
            <Button className="btn" color='primary' fill='none' onClick={goJiaoyi}>
                {t('zf5')}
            </Button>
        </div>
    );
};
